import React from "react";
import { Header } from "../../components/Header";
import { DeveloperBanner } from "../../blocks/developer-banner";
import { DeveloperUse } from "../../blocks/developer-use";
import { DeveloperStatus } from "../../blocks/developer-status";
import { DeveloperSdk } from "../../blocks/developer-sdk";

import { DeveloperAuthorize } from "../../blocks/developer-authorize";
import { DeveloperSecurity } from "../../blocks/developer-security";
import { DeveloperThirdLogin } from "../../blocks/developer-thirdparty-login";
import { DeveloperFormLogin } from "../../blocks/developer-form-login";
import { DeveloperScanLogin } from "../../blocks/developer-scan-login";
import { DeveloperPractice } from "../../blocks/developer-practice";
import { DeveloperOther } from "../../blocks/developer-other";
// import { Helmet } from "react-helmet";
import "./styles.less";
import { Footer } from "../../components/FooterV2";
import { Helmet } from "react-helmet";
import { Notice } from "../../components/Notice";
// import { useTranslation } from "react-i18next";

export const DeveloperPage = () => {
  // const { t } = useTranslation();
  return (
    <div className="solution-page">
      <Helmet>
        <title>
          Authing身份云开发者中心，身份验证API，身份认证产品-Authing身份云
        </title>
      </Helmet>
      <Header mode={"light"} hasNotice />
      <DeveloperBanner />
      <DeveloperStatus />
      <DeveloperUse />
      <DeveloperSdk />
      <DeveloperAuthorize />
      <DeveloperSecurity />
      <DeveloperThirdLogin />
      <DeveloperFormLogin />
      <DeveloperScanLogin />
      <DeveloperPractice />
      <DeveloperOther />
      <Footer />
    </div>
  );
};
